<script>
    import CarItem from './CarItem.svelte';
    import { t } from '$lib/i18n.js';
    import { page } from '$app/stores';
    import { onMount } from 'svelte';
    import { browser } from '$app/environment';

    // I dati delle auto vengono passati dalla load function (SSR)
    $: vehicles = $page.data.vehicles || [];
    $: carsLoaded = $page.data.carsLoaded !== false;
    $: error = $page.data.error || null;
    
    // Limita il numero di auto mostrate
    let isDesktop = true;
    
    // Reactive per determinare quante auto mostrare
    $: maxCars = isDesktop ? 8 : 4;
    $: visibleVehicles = vehicles.slice(0, maxCars);
    
    // Funzione per controllare se siamo su desktop
    function checkIsDesktop() {
        if (browser) {
            isDesktop = window.innerWidth > 768;
        }
    }
    
    onMount(() => {
        if (browser) {
            checkIsDesktop();
            window.addEventListener('resize', checkIsDesktop);
            
            return () => {
                window.removeEventListener('resize', checkIsDesktop);
            };
        }
    });
</script>

<section>
    <div class="col"> 
    <h2>🚗<br/>{$t('routes.home.cars_grid.title')}</h2>
    {#if !carsLoaded}
        <div class="loading-container">
            <div class="loader"></div>
            <p>{$t('routes.home.cars_grid.loading')}</p>
        </div>
    {:else if error}
        <div class="error-container">
            <p>❌ {$t('routes.home.cars_grid.error', { error })}</p>
        </div>
    {:else if vehicles.length === 0}
        <div class="error-container">
            <p>⚠️ {$t('routes.home.cars_grid.no_vehicles')}</p>
        </div>
    {:else}
        <div class="cars-grid">
            {#each visibleVehicles as vehicle (vehicle.id)}
                <CarItem 
                    name={vehicle.name}
                    currency={vehicle.currency}
                    price={vehicle.price}
                    stars={vehicle.stars}
                    image={vehicle.image}
                    imageAlt={vehicle.imageAlt}
                    userId={vehicle.owner.id}
                    carId={vehicle.id}
                />
            {/each}
        </div>
    {/if}
</div>
</section>

<style>
    section {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 1rem 2rem;
        gap: 24px;
        width: 100%;
        padding-top: 120px;
    }

    .col {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        max-width: var(--max-width);
        width: 100%;
    }

    .cars-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 16px;
        width: 100%;
    }

    h2 {
        text-align: center;
    }

    /* Loading spinner */
    .loading-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 3rem;
        gap: 1rem;
    }

    .loader {
        border: 4px solid #f3f3f3;
        border-top: 4px solid var(--orange);
        border-radius: 50%;
        width: 50px;
        height: 50px;
        animation: spin 1s linear infinite;
    }

    .loading-container p {
        color: var(--color-text-secondary);
        font-size: 1rem;
        margin: 0;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    /* Error state */
    .error-container {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2rem;
        background: #fee;
        border: 1px solid #fcc;
        border-radius: 8px;
        margin: 1rem 0;
    }

    .error-container p {
        color: #c33;
        font-size: 1rem;
        margin: 0;
    }

    @media (max-width: 768px) {
        section {
            padding: 1rem;
            align-items: center;
            padding-top: 120px;
        }

        .col {
            align-items: center;
        }

        .cars-grid {
            grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
            gap: 32px;
        }

        .loader {
            width: 40px;
            height: 40px;
        }

        .loading-container {
            padding: 2rem;
        }
    }
</style>